
import { useState, useEffect, useRef } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsServicesOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3 cursor-pointer">
            <span
              className={`text-2xl font-bold transition-colors duration-300 ${
                isScrolled ? 'text-slate-900' : 'text-white'
              }`}
            >
              康顧 CORE UNITY
            </span>
          </a>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <a
              href="/"
              className={`font-semibold transition-colors duration-300 hover:text-orange-500 cursor-pointer ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              首頁
            </a>

            {/* Services Dropdown */}
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setIsServicesOpen((prev) => !prev)}
                className={`font-semibold transition-colors duration-300 hover:text-orange-500 flex items-center gap-1 whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-slate-700' : 'text-white'
                }`}
              >
                服務項目
                <i className={`ri-arrow-down-s-line transition-transform duration-200 ${isServicesOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {/* Dropdown Menu */}
              {isServicesOpen && (
                <div className="absolute top-full left-0 mt-2 w-72 bg-white rounded-xl shadow-xl border border-gray-100 py-2">
                  <a
                    href="/services/rehabilitation-outreach"
                    onClick={() => setIsServicesOpen(false)}
                    className="block px-5 py-4 text-slate-700 hover:bg-orange-50 hover:text-orange-600 transition-colors duration-200 cursor-pointer"
                  >
                    <div className="font-semibold text-sm">專業復康外展服務</div>
                    <div className="text-xs text-slate-500 mt-1">物理治療 · 職業治療 · 言語治療</div>
                  </a>
                  <a
                    href="/services/equipment-monitoring"
                    onClick={() => setIsServicesOpen(false)}
                    className="block px-5 py-4 text-slate-700 hover:bg-orange-50 hover:text-orange-600 transition-colors duration-200 cursor-pointer"
                  >
                    <div className="font-semibold text-sm">復康訓練器材及監測系統</div>
                    <div className="text-xs text-slate-500 mt-1">智能器材 · 監測系統 · 資助申請</div>
                  </a>
                  <a
                    href="/services/renovation"
                    onClick={() => setIsServicesOpen(false)}
                    className="block px-5 py-4 text-slate-700 hover:bg-orange-50 hover:text-orange-600 transition-colors duration-200 cursor-pointer"
                  >
                    <div className="font-semibold text-sm">院舍改善工程</div>
                    <div className="text-xs text-slate-500 mt-1">空間規劃 · 牌照顧問 · 工程施工</div>
                  </a>
                </div>
              )}
            </div>

            <a
              href="/#about"
              className={`font-semibold transition-colors duration-300 hover:text-orange-500 cursor-pointer ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              關於我們
            </a>
            <a
              href="/contact"
              className={`font-semibold transition-colors duration-300 hover:text-orange-500 cursor-pointer ${
                isScrolled ? 'text-slate-700' : 'text-white'
              }`}
            >
              聯絡我們
            </a>
            <a
              href="/contact#inquiry-form"
              className="bg-orange-500 text-white font-bold px-6 py-3 rounded-full hover:bg-orange-600 transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              免費諮詢
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
